import { render, staticRenderFns } from "./caracteristicaPedidoForm.vue?vue&type=template&id=65302888&"
import script from "./caracteristicaPedidoForm.vue?vue&type=script&lang=js&"
export * from "./caracteristicaPedidoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports